/* RAVIN / THE BAG CATCH — 19 OCT 2026
   Visual-only cart success feedback. This script never sends cart requests,
   changes inventory, modifies prices, replaces cart fragments or opens drawers.
   Supported: RAVIN PDP main/sticky Add to Bag and Shopify product-form quick add. */
(()=>{
  'use strict';
  if(window.__ravinBagCatch2026)return;
  window.__ravinBagCatch2026=true;
  const SELECTOR='[data-add-to-cart],[data-sticky-add-to-cart],product-form button[type="submit"],form[action*="/cart/add"] button[type="submit"]';
  const ttl=15000;
  let pending=null,flight=null,labelTimer=0,hitTimer=0,lastPulse=0;
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile=()=>window.matchMedia('(max-width: 749px)').matches;
  const arabic=()=>document.documentElement.lang.toLowerCase().startsWith('ar');
  const safeUrl=value=>{
    if(typeof value!=='string'||!value.trim())return '';
    try{
      const url=new URL(value,location.href);
      return url.protocol==='https:'||url.protocol==='http:'?url.href:'';
    }catch(e){return ''}
  };
  const center=rect=>({x:rect.left+rect.width/2,y:rect.top+rect.height/2});
  const within=rect=>rect&&rect.width>0&&rect.height>0&&
    rect.right>0&&rect.left<innerWidth&&rect.bottom>0&&rect.top<innerHeight;
  function photoIn(host){
    if(!host)return '';
    const selectors=[
      '[data-ravin-arc-card].is-active img',
      '[data-ravin-deck-card].is-active img',
      '[data-ravin-3d-card].is-active img',
      '.ravin-pdp-3d-card.is-active img',
      '[data-media-index] img:not([hidden])',
      '.product__media-item.is-active img',
      '.product-media-container img',
      '.card__media img',
      '[data-rcc-card] img'
    ];
    for(const selector of selectors){
      const img=host.querySelector(selector);
      if(img&&img.getAttribute('src'))return safeUrl(img.currentSrc||img.src||img.getAttribute('src'));
    }
    return '';
  }
  function capture(button){
    if(!button||button.disabled||button.getAttribute('aria-disabled')==='true')return;
    const form=button.closest('form')||
      button.closest('[data-rv-pdp-garment-file]')?.querySelector('[data-product-form]')||
      button.closest('product-form')?.querySelector('form');
    const host=button.closest('[data-rv-pdp-garment-file]')||
      button.closest('quick-add-modal')||
      button.closest('product-form')||
      button.closest('[data-rcc-card]')||
      button.closest('.card-wrapper')||
      form?.closest('.product')||null;
    const rect=button.getBoundingClientRect();
    if(!within(rect))return;
    const variant=String(form?.querySelector('[name="id"]')?.value||'').trim();
    const image=photoIn(host)||photoIn(button.closest('.card'))||
      (host?.matches?.('product-form')?photoIn(host.closest('.quick-add-modal')):'');
    pending={at:Date.now(),origin:center(rect),photo:image,variant};
    button.classList.add('rv-bag-catch--pressed');
    setTimeout(()=>button.classList.remove('rv-bag-catch--pressed'),165);
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest?.(SELECTOR);
    if(button)capture(button);
  },true);
  document.addEventListener('submit',event=>{
    if(!event.target.matches?.('form[action*="/cart/add"],product-form form,[data-product-form]'))return;
    const button=event.submitter||event.target.querySelector('button[type="submit"]');
    if(button&&!pending)capture(button);
  },true);
  function bagPosition(){
    const header=document.querySelector('#cart-icon-bubble');
    if(header&&within(header.getBoundingClientRect())&&getComputedStyle(header).visibility!=='hidden'){
      return {element:header,point:center(header.getBoundingClientRect()),floating:false};
    }
    const right=arabic()?false:true;
    let fallback=document.querySelector('[data-rv-bag-catch-target]');
    if(!fallback){
      fallback=document.createElement('div');
      fallback.className='rv-bag-catch__virtual-bag';
      fallback.setAttribute('data-rv-bag-catch-target','');
      fallback.setAttribute('aria-hidden','true');
      const svg=header?.querySelector('svg');
      if(svg)fallback.append(svg.cloneNode(true));
      else fallback.textContent='▢';
      document.body.append(fallback);
    }
    fallback.style.left=right?'auto':'14px';
    fallback.style.right=right?'14px':'auto';
    fallback.classList.add('is-visible');
    return {element:fallback,point:center(fallback.getBoundingClientRect()),floating:true};
  }
  function status(){
    let live=document.getElementById('rv-bag-catch-live');
    if(!live){
      live=document.createElement('div');live.id='rv-bag-catch-live';
      live.className='rv-bag-catch__sr';live.setAttribute('role','status');
      live.setAttribute('aria-live','polite');
      document.body.append(live);
    }
    live.textContent=arabic()?'اتضاف للشنطة':'Added to bag';
  }
  function confirmation(target){
    clearTimeout(labelTimer);
    document.querySelector('.rv-bag-catch__confirmed')?.remove();
    const el=document.createElement('div');
    el.className='rv-bag-catch__confirmed';
    el.textContent=arabic()?'اتضاف للشنطة ✓':'ADDED TO BAG ✓';
    el.setAttribute('aria-hidden','true');
    const x=target.point.x,y=target.point.y;
    const w=Math.min(145,innerWidth-20);
    el.style.left=Math.max(10,Math.min(innerWidth-w-10,x-w/2))+'px';
    el.style.top=Math.max(65,Math.min(innerHeight-44,y+33))+'px';
    document.body.append(el);
    labelTimer=setTimeout(()=>el.remove(),1550);
  }
  function land(bag){
    clearTimeout(hitTimer);
    const el=bag.element;
    el.classList.remove('rv-bag-catch--impact');
    void el.offsetWidth;
    el.classList.add('rv-bag-catch--impact');
    lastPulse=Date.now();
    confirmation(bag);
    hitTimer=setTimeout(()=>{
      el.classList.remove('rv-bag-catch--impact');
      if(bag.floating)el.classList.remove('is-visible');
    },800);
  }
  const bezier=(a,b,c,d,t)=>{
    const u=1-t;
    return u*u*u*a+3*u*u*t*b+3*u*t*t*c+t*t*t*d;
  };
  function animateCard(action,bag,src){
    if(flight){cancelAnimationFrame(flight.raf);flight.card.remove();flight=null}
    const card=document.createElement('div');
    card.className='rv-bag-catch__flight';
    if(src){
      const img=document.createElement('img');
      img.alt='';img.draggable=false;img.src=src;img.decoding='async';
      card.append(img);
    }else{
      const title=document.createElement('span');title.textContent='RAVIN';card.append(title);
    }
    document.body.append(card);
    const p=action.origin,q=bag.point;
    const d=Math.abs(q.y-p.y);
    const c1={x:p.x+(q.x-p.x)*.13,y:p.y-Math.max(42,Math.min(170,d*.36))};
    const c2={x:p.x+(q.x-p.x)*.82,y:q.y+Math.max(18,Math.min(100,d*.13))};
    const duration=900,begin=performance.now();
    let landed=false;
    const frame=now=>{
      const t=Math.min(1,(now-begin)/duration);
      const ease=1-Math.pow(1-t,2.4);
      const x=bezier(p.x,c1.x,c2.x,q.x,ease);
      const y=bezier(p.y,c1.y,c2.y,q.y,ease);
      card.style.left=x+'px';
      card.style.top=y+'px';
      card.style.transform='translate(-50%,-50%) perspective(650px) rotateY('+
        (16*(1-ease)).toFixed(2)+'deg) rotateZ('+((1-ease)*-13).toFixed(2)+
        'deg) scale('+(1-.72*ease).toFixed(3)+')';
      card.style.opacity=String(t>.85?Math.max(0,1-(t-.85)/.15):1);
      if(t>.87&&!landed){landed=true;land(bag)}
      if(t<1){
        flight.raf=requestAnimationFrame(frame);
      }else{
        card.remove();flight=null;
      }
    };
    flight={card,raf:requestAnimationFrame(frame)};
  }
  function added(detail){
    if(!pending||Date.now()-pending.at>ttl){pending=null;return}
    const action=pending;
    const response=detail?.cartData||detail||{};
    // Do not borrow unrelated cart updates to confirm a failed product addition.
    const id=String(detail?.productVariantId||response.variant_id||response.id||response.items?.[0]?.variant_id||'');
    if(action.variant&&id&&action.variant!==id)return;
    pending=null;
    const bag=bagPosition();
    status();
    const src=safeUrl(response.featured_image?.url||response.image||response.items?.[0]?.image)||action.photo;
    if(motion.matches||!within({left:action.origin.x,top:action.origin.y,width:1,height:1,right:action.origin.x+1,bottom:action.origin.y+1})){
      land(bag);
    }else animateCard(action,bag,src);
  }
  window.addEventListener('cart:updated',e=>added(e.detail));
  function connectPubSub(){
    // Dawn exposes PUB_SUB_EVENTS as a top-level const, not window.PUB_SUB_EVENTS.
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){
      subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{
        if(event?.source==='product-form'||event?.source==='ravin-product')added(event);
      });
    }
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',connectPubSub,{once:true});
  }else connectPubSub();
})();